import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const AUDIT_ANALYTICS_ACTIONS = {
  // WRITE_ACTIONS
  UPDATED_DATA_MODS_SETTING: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.AUDIT,
    action: 'updated_data_mods_setting',
  },
  UPDATED_DATA_MODS_ENABLED_PROJECTS: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.AUDIT,
    action: 'updated_data_mods_enabled_projects',
  },
  UPDATED_DATA_MODS_FOLDER_MOVEMENT_SETTING: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.AUDIT,
    action: 'updated_data_mods_folder_movement_setting',
  },
};
